export const DEFAULT_ARTIST_IMAGE = "https://placehold.co/600x400?text=Artist+Image";
export const DEFAULT_PROFILE_IMAGE = "https://placehold.co/400x400?text=Profile+Image";
export const DEFAULT_BANNER_IMAGE = "https://placehold.co/1200x400?text=Banner+Image"; 